import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import SelectField from '../SelectField/SelectField';

const edition_id = (edition) => String(edition?._id || edition?.id || '');

const EditionsField = ({ name }) => {
    const { t } = useTranslation();
    const editions = useSelector((state) => state.editionNavigation?.editions);
    const options = (Array.isArray(editions) ? editions : [])
        .map((edition) => {
            const id = edition_id(edition);
            if (!id)
                return null;
            return { key: id, text: id, value: id };
        })
        .filter(Boolean);

    return (
        <SelectField
            name={name}
            options={options}
            placeholder={t('settings.mobile.edition_placeholder')}
            clearable
        />
    );
};

export default EditionsField;
